
<!--
Container for the photo-gallery-dialog:
(keydown) events:
Handles scrolling with the dialog
-->
<lc-base-dialog id="photo-gallery-dialog" [title]="title" (actionClicked)="onClose()" (keydown.arrowleft)="prevSlide()" (keydown.arrowright)="nextSlide()" >

  <!--Modal Body-->
  <ng-template #content>
    @if (photos) {
      <div class="fx-column fx-grow fx-gap-xs">
        <div class="photo-gallery fx-row fx-gap-xs y-center x-space-between" style="min-height: 365px;">
          <!-- Left Scroll Button -->
          <button class="back fx-0-0" mat-icon-button (click)="prevSlide()">
            <mat-icon>chevron_left</mat-icon>
          </button>
          <!-- Carousel Container-->
          <div class="h-100 w-100" [@slideAnimation]="currentIndex">
            @for (vm of photoViewModels; track vm; let i = $index) {
              @if (isCurrentSlideIndex(i)) {
                <div class="image-wrapper" (swipeleft)="nextSlide()" (swiperight)="prevSlide()">
                  <div class="image-container">
                    <lc-photo
                      [deleteStyle]="'CAROUSEL'"
                      [iconsPersist]="true"
                      [roundImg]="false"
                      [thumbnailSize]="thumbnailSize"
                      [viewModel]="vm"
                      (delete)="handleDelete($event)"
                      (edit)="handleEdit($event)"
                      (toggleFavorites)="handleToggleFavorites($event)"
                      />
                  </div>
                </div>
              }
            }
          </div>
          <!-- Right Scroll Button -->
          <button class="forward fx-0-0" mat-icon-button (click)="nextSlide()">
            <mat-icon>chevron_right</mat-icon>
          </button>
        </div>
        <div class="fx-row x-center">
          <span class="font-weight-bold photo-index">Photo {{selectedIndex + 1}} of {{photos.length}}</span>
        </div>
        @if (aiFeatureIsEnabled$ | async) {
          <div>
            <!-- <div class="fx-column fx-gap-xs">
              <lc-textarea
                class=""
                label="Caption"
                placeholder="i.e., Charming home with vaulted ceilings and..."
                rows="3"
                [formControl]="photoForms[selectedIndex].getControl('caption')" />
            </div> -->
            <div class="fx-column fx-gap-xs">
              <lc-chips
                hint="Add or remove property features from the photo that you would like to add to this property."
                label="Key Property Features"
                placeholder="i.e., pool, patio, stainless steel appliances, etc." size="md" [allowCustomInput]="true"
                [formControl]="photoForms[selectedIndex].getControl('tags')" />
            </div>
          </div>
        }
      </div>
    }
  </ng-template>

  <ng-template #actions>
    @if (aiFeatureIsEnabled$ | async) {
      <div class="fx-row x-space-between py-md">
        <button color="primary" id="property-description-cancel" mat-stroked-button style="margin: 0;"
          type="button" (click)="onClose()">
          Back
        </button>
        <button color="primary" id="property-description-submit m-0" mat-raised-button style="margin: 0;"
          type="submit" [disabled]="disableSave" (click)="onSave()">
          Save
        </button>
      </div>
    }
  </ng-template>
</lc-base-dialog>
